import { HeadCell } from '@dfl/mui-admin-layout';
import { ReactLink } from '@dfl/react-security';
import { createdATColumn } from 'modules/common/constants';
import { BusinessAccountRequestStatusCell } from '../components/BusinessAccountRequestStatusCell';
// import { BusinessAccountRequestSectorCell } from '../components/BusinessAccountRequestSectorCell';
import { BusinessAccountRequestDocumentsCell } from '../components/BusinessAccountRequestDocumentsCell';
import { BusinessAccountRequestRowActions } from '../components/BusinessAccountRequestRowActions';
import { BUSINESS_ACCOUNT_REQUEST_PERMISSIONS } from './business-account-request.permissions';
import { IBusinessAccountRequest, IBusinessAccountRequestCompany, IBusinessAccountRequestRepresentative } from '../interfaces';

export const businessAccountRequestCompanyColumn: HeadCell<IBusinessAccountRequest> = {
  field: 'company',
  headerName: 'businessAccountRequest:fields.commercialName',
  minWidth: 200,
  flex: 1,
  renderCell: (company: IBusinessAccountRequestCompany, data: IBusinessAccountRequest) => (
    <ReactLink to={`/crm/clients/business-requests/${data?._id}`} underline='hover'>
      {company?.commercialName}
    </ReactLink>
  ),
};

export const businessAccountRequestTaxIdColumn: HeadCell<IBusinessAccountRequest> = {
  field: 'company.taxId',
  sortable: false,
  headerName: 'businessAccountRequest:fields.taxId',
  width: 140,
  renderCell: (_: unknown, data: IBusinessAccountRequest) => data?.company?.taxId,
};

export const businessAccountRequestRepresentativeColumn: HeadCell<IBusinessAccountRequest> = {
  field: 'representative',
  sortable: false,
  headerName: 'businessAccountRequest:fields.representative',
  minWidth: 180,
  renderCell: (representative: IBusinessAccountRequestRepresentative) => representative?.name,
};

// export const businessAccountRequestSectorColumn: HeadCell<IBusinessAccountRequest> = {
//   field: 'company.sector',
//   sortable: false,
//   headerName: 'businessAccountRequest:fields.sector',
//   width: 180,
//   renderCell: (_: unknown, data: IBusinessAccountRequest) => (
//     <BusinessAccountRequestSectorCell sector={data?.company?.sector} />
//   ),
// };

export const businessAccountRequestDocumentsColumn: HeadCell<IBusinessAccountRequest> = {
  field: 'documents',
  sortable: false,
  headerName: 'businessAccountRequest:fields.documentsShort',
  width: 160,
  renderCell: (documents: IBusinessAccountRequest['documents']) => (
    <BusinessAccountRequestDocumentsCell documents={documents} />
  ),
};

export const businessAccountRequestStatusColumn: HeadCell<IBusinessAccountRequest> = {
  field: 'status',
  headerName: 'common:status',
  width: 140,
  renderCell: (status: IBusinessAccountRequest['status']) => <BusinessAccountRequestStatusCell status={status} />,
};

export const businessAccountRequestActionsColumn: HeadCell<IBusinessAccountRequest> = {
  field: 'actions',
  sortable: false,
  width: 220,
  permissions: BUSINESS_ACCOUNT_REQUEST_PERMISSIONS.BUSINESS_ACCOUNT_REQUEST_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: BusinessAccountRequestRowActions,
};

export const businessAccountRequestColumns: Array<HeadCell<IBusinessAccountRequest>> = [
  businessAccountRequestCompanyColumn,
  businessAccountRequestTaxIdColumn,
  businessAccountRequestRepresentativeColumn,
  // businessAccountRequestSectorColumn,
  businessAccountRequestDocumentsColumn,
  businessAccountRequestStatusColumn,
  createdATColumn,
  businessAccountRequestActionsColumn,
];
